import React from 'react';
import PropTypes from 'prop-types';
import romanize from 'romanize';

import { connect } from 'react-redux';
import moment from 'moment';
import { getEnvironment } from '../../AppReducer';

// Import Style
import styles from './Footer.css';

function Footer(props) {
  const { environment } = props;
  const isProduction = environment === 'production';
  const year = romanize(parseInt(moment().format('YYYY'), 10));
  return (
    <footer id="app-footer" className={`${styles.footer} footer`}>
      <div className={`${styles.footerContainer} container`}>
        <div className="clearfix">
          <div className={`${styles.legal}`}>
            &copy;{year} <a href="http://truvoice.io/" target="_blank" rel="noopener noreferrer">{(process.env.REACT_APP_APP_TITLE || 'TruVoice by Corporate Visions')}</a>
          </div>
          <div className={`${styles.version}`}>
            {!isProduction && environment !== null && <span><span className="label label-warning text-uppercase">{environment}</span>{' '}</span>}
            {process.env.REACT_APP_APP_VERSION !== undefined && <span>{process.env.REACT_APP_APP_VERSION}</span>}
          </div>
        </div>
      </div>
    </footer>
  );
}

function mapStateToProps() {
  return {
    environment: getEnvironment(),
  };
}

Footer.propTypes = {
  environment: PropTypes.string,
};
Footer.defaultProps = {
  environment: null,
};
export default connect(mapStateToProps)(Footer);
